import React from 'react';
import { Modal } from "react-bootstrap";
import './InfoModal.css';

interface InfoModalProps {
  show: boolean;
  onHide: () => void;
  type: 'pull' | 'push';
}

const InfoModal: React.FC<InfoModalProps> = ({ show, onHide, type }) => {

    const pullMessage = "In pull mode data is pulled from all partnerships to a single partner."
    const pushMessage = "In push mode, data is pushed from a single partnership to all its partners."

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      centered
      scrollable={false}
      className="select-returntype-custom-modal"
    >
      <Modal.Header closeButton>
        <h5>&nbsp;{ type == 'pull' ? pullMessage:pushMessage }</h5>
      </Modal.Header>
      <Modal.Body>
        {type === 'pull' ? (
          <div className="info-modal-flow-container">
            <div className="info-modal-box info-modal-top-left">
              <strong>Good Partnership</strong>
              <div>1065</div>
            </div>
            <div className="info-modal-box info-modal-top-right">
              <strong>Another Good Partnership</strong>
              <div>1065</div>
            </div>
            <div className="info-modal-box info-modal-bottom info-modal-bottom-box">
              <strong>Partner One</strong>
              <div>1040/1065</div>
            </div>
            <svg className="info-modal-svg">
              <path
                className="info-modal-path"
                d="M180,120 C300,200 300,200 400,240"
              />
              <path
                className="info-modal-path"
                d="M620,120 C500,200 500,200 400,240"
              />
              <circle
                className="info-modal-flow-circle"
                style={{ offsetPath: 'path("M180,120 C300,200 300,200 400,240")' }}
              />
              <circle
                className="info-modal-flow-circle"
                style={{ offsetPath: 'path("M620,120 C500,200 500,200 400,240")' }}
              />
            </svg>
          </div>
        ) : (
          <div className="info-modal-flow-container">
            <div className="info-modal-box info-modal-top-center">
              <strong>Another Good Partnership</strong>
              <div>1065</div>
            </div>
            <div className="info-modal-box info-modal-bottom-left info-modal-bottom-box">
              <strong>Partner One</strong>
              <div>1040/1065</div>
            </div>
            <div className="info-modal-box info-modal-bottom-center info-modal-bottom-box">
              <strong>Partner Two</strong>
              <div>1040/1065</div>
            </div>
            <div className="info-modal-box info-modal-bottom-right info-modal-bottom-box">
              <strong>Partner Three</strong>
              <div>1040/1065</div>
            </div>
            <svg className="info-modal-svg">
              <path
                className="info-modal-path"
                d="M400,130 C400,170 250,210 200,260"
              />
              <path
                className="info-modal-path"
                d="M400,130 C400,180 400,210 400,260"
              />
              <path
                className="info-modal-path"
                d="M400,130 C400,170 550,210 600,260"
              />
              <circle
                className="info-modal-flow-circle"
                style={{ offsetPath: 'path("M400,130 C400,170 250,210 200,260")' }}
              />
              <circle
                className="info-modal-flow-circle"
                style={{ offsetPath: 'path("M400,130 C400,180 400,210 400,260")' }}
              />
              <circle
                className="info-modal-flow-circle"
                style={{ offsetPath: 'path("M400,130 C400,170 550,210 600,260")' }}
              />
            </svg>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default InfoModal;
